import React from 'react';

import {Container, Card, Value, Label, Row} from './styles';

export interface AnalyticsCardProps {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
  customValue?: (value: string | number) => string;
  onClick?: () => void;
  hidden?: boolean;
}

export interface Props {
  data: AnalyticsCardProps | AnalyticsCardProps[];
  children?: React.ReactNode;
}

export const renderCard = ({
  value,
  label,
  icon,
  onClick,
  customValue,
}: AnalyticsCardProps) => (
  <Card key={label} {...{onClick}}>
    <Row>
      <Value>{customValue ? customValue(value) : value}</Value>
      {icon}
    </Row>
    <Label>{label}</Label>
  </Card>
);

const AnalyticsCard: React.FC<Props> = ({data, children}) => {
  if (!Array.isArray(data)) return renderCard(data);

  return (
    <Container>
      {data.map((card) => renderCard(card))}
      {children}
    </Container>
  );
};

export default AnalyticsCard;
